import * as PIXI from "pixi.js";
import {texture} from "../core/AssetHelpers";
import {Particles} from "../core/Particles";
import {Callback} from "../core/Reflection";

export class BurstSparkleEffect extends Particles {

    constructor() {
        super(texture("particle-square")!, {
            alpha: {
                start: 1,
                end: 0,
            },
            scale: {
                start: 0.1,
                end: 1,
                minimumScaleMultiplier: 0.5,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 400,
                end: 400,
                minimumSpeedMultiplier: 0.5,
            },
            acceleration: {
                x: 0,
                y: 600,
            },
            maxSpeed: 0,
            startRotation: {
                min: -180,
                max: 0,
            },
            noRotation: true,
            rotationSpeed: {
                min: 0,
                max: 0,
            },
            lifetime: {
                min: 0.6,
                max: 0.8,
            },
            blendMode: "normal",
            frequency: 0.005,
            emitterLifetime: 0.2,
            maxParticles: 40,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point",
        });
        this.emitter.emit = false;
        this.emitter.autoUpdate = true;
    }

    public static play(parent: PIXI.Container, x: number, y: number, scale: number, cb?: Callback): BurstSparkleEffect {
        const burst = parent.addChild(new BurstSparkleEffect());
        burst.scaleXY = scale;
        burst.x = x;
        burst.y = y;
        burst.emitter.autoUpdate = true;
        burst.emitter.emit = true;
        burst.emitter.playOnceAndDestroy(cb);
        return burst;
    }
}
